import { MiscType } from './misc-data.type';

export const setOrderId = (data) => ({
  type: MiscType.setOrderId,
  payload: data
  
});
export const setPhone = (data) => ({
    type: MiscType.setPhone,
    payload: data
    
  });
  export const setAmount = (data) => ({
    type: MiscType.setAmount,
    payload: data
    
  }); 

  export const setMoneyTransferTotalAmount = (data) => ({
    type: MiscType.setMoneyTransferTotalAmount,
    payload: data
    
  }); 
  export const setTransactionId = (data) => ({
    type: MiscType.setTransactionId,
    payload: data
      
  }); 

  export const setOtp = (data) => ({
    type: MiscType.setOtp,
    payload: data
    
  });
  export const setOtpRefNo = (data) => ({
    type: MiscType.setOtpRefNo,
    payload: data
    
  });
  export const setOrderServiceResponse = (data) => ({
    type: MiscType.setOrderServiceResponse,
    payload: data
    
  });

  export const setUserFirstName = (data) => ({
    type: MiscType.setUserFirstName,
    payload: data
    
  });


  export const setDeviceInfo = (data) => ({
    type: MiscType.setDeviceInfo,
    payload: data
    
  });

  export const setUserRegisterData = (data) => ({
    type: MiscType.setUserRegisterData,
    payload: data
    
  });


  export const setCompleteOrderId = (data) => ({
    type: MiscType.setCompleteOrderId,
    payload: data
    
  });

  export const setTxnLoader = (data) => ({
    type: MiscType.setTxnLoader,
    payload: data
    
  });

  export const setUploadedFiles = (data) => ({
    type: MiscType.setUploadedFile,
    payload: data
    
  });

  export const setActiveLinkStatus = (data) => ({
    type: MiscType.setActiveLinkStatus,
    payload: data
    
  });


  
  export const setToken = (data) => ({
    type: MiscType.setToken,
    payload: data
    
  });


  export const setAgentInfo = (data) => ({
    type: MiscType.setAgentInfo,
    payload: data
    
  });



  export const setAddSenderRequest = (data) => ({
    type: MiscType.setAddSenderRequest,
    payload: data
    
  });

  export const setAddSenderRequestUrl = (data) => ({
    type: MiscType.setAddSenderRequestUrl,
    payload: data
    
  });


  export const setBenefisciaryList = (data) => ({
    type: MiscType.setBenefisciaryList,
    payload: data
    
  });

  
  export const setAddBenefisciaryRequest = (data) => ({
    type: MiscType.setAddBenefisciaryRequest,
    payload: data
    
  });


  export const setAddBenefisciaryRequestUrl = (data) => ({
    type: MiscType.setAddBenefisciaryRequestUrl,
    payload: data
    
  });


  export const setStateDetails = (data) => ({
    type: MiscType.setStateDetails,
    payload: data
    
  });

  export const setCityList = (data) => ({
    type: MiscType.setCityList,
    payload: data
    
  });

  export const setBranchList = (data) => ({
    type: MiscType.setBranchList,
    payload: data
    
  });

  export const setIfscCode = (data) => ({
    type: MiscType.setIfscCode,
    payload: data
    
  });

  export const setSendersListDetails = (data) => ({
    type: MiscType.setSendersListDetails,
    payload: data
    
  });

  export const setMoneyTransferSurChargeAmount = (data) => ({
    type: MiscType.setMoneyTransferSurChargeAmount,
    payload: data
    
  });

  export const setBankDetails = (data) => ({
    type: MiscType.setBankDetails,
    payload: data
    
  });

  export const setSelectedBankName = (data) => ({
    type: MiscType.setSelectedBankName,
    payload: data
    
  });

  
  export const setSelectedBankId = (data) => ({
    type: MiscType.setSelectedBankId,
    payload: data
    
  });

  export const selectedBankDetails = (data) => ({
    type: MiscType.selectedBankDetails,
    payload: data
    
  });

  export const setOtpResponse = (data) => ({
    type: MiscType.setOtpResponse,
    payload: data
    
  });


  export const setBranchAddress = (data) => ({
    type: MiscType.setBranchAddress,
    payload: data
    
  });

  export const selectedSender = (data) => ({
    type: MiscType.selectedSender,
    payload: data
    
  });

  export const setBeneSubDetails = (data) => ({
    type: MiscType.setBeneSubDetails,
    payload: data
    
  });

  export const setCreteOrderReq = (data) => ({
    type: MiscType.setCreteOrderReq,
    payload: data
    
  });

  export const setCreateOrderRes = (data) => ({
    type: MiscType.setCreateOrderRes,
    payload: data
    
  });

  export const setBeneMoneyTransfer = (data) => ({
    type: MiscType.setBeneMoneyTransfer,
    payload: data
    
  });

  export const setActiveStatus = (data) => ({
    type: MiscType.setActiveStatus,
    payload: data
    
  });

  
  export const setLogOutWarningStatus = (data) => ({
    type: MiscType.setLogOutWarningStatus,
    payload: data
    
  });


  export const setLoginTimestamp = (data) => ({
    type: MiscType.setLoginTimestamp,
    payload: data
    
  });

  export const setTxnAmount = (data) => ({
    type: MiscType.setTxnAmount,
    payload: data
    
  });

  export const setTxnsurcharge = (data) => ({
    type: MiscType.setTxnsurcharge,
    payload: data
    
  });

  
  export const setTxntotalAmount = (data) => ({
    type: MiscType.setTxntotalAmount,
    payload: data
    
  });

    
  export const setMoneyTransferProgress = (data) => ({
    type: MiscType.setMoneyTransferProgress,
    payload: data
    
  });

  export const setStatusEnqResponse = (data) => ({
    type: MiscType.setStatusEnqResponse,
    payload: data
    
  });

  export const setTxnHistoryResponse = (data) => ({
    type: MiscType.setTxnHistoryResponse,
    payload: data
    
  });

  export const setCustomerLimit = (data) => ({
    type: MiscType.setCustomerLimit,
    payload: data
    
  });

  export const selectedBeneList = (data) => ({
    type: MiscType.selectedBeneList,
    payload: data
    
  });

  export const setTxnReportingData = (data) => ({
    type: MiscType.setTxnReportingData,
    payload: data
    
  });

  export const setTxnHistoryElementNo = (data) => ({
    type: MiscType.setTxnHistoryElementNo,
    payload: data
    
  });

  export const setTxnHistoryPaginationResponse = (data) => ({
    type: MiscType.setTxnHistoryPaginationResponse,
    payload: data
    
  });

  export const setTotalSenders = (data) => ({
    type: MiscType.setTotalSenders,
    payload: data
    
  });

  export const setSendersListPageDetails = (data) => ({
    type: MiscType.setSendersListPageDetails,
    payload: data
    
  });

  export const setBankLogoList = (data) => ({
    type: MiscType.setBankLogoList,
    payload: data
    
  });

  export const setSenderCustomerId = (data) => ({
    type: MiscType.setSenderCustomerId,
    payload: data
    
  });

  export const setBeneCustomerId = (data) => ({
    type: MiscType.setBeneCustomerId,
    payload: data
    
  });

  
  export const setGraphResponse = (data) => ({
    type: MiscType.setGraphResponse,
    payload: data
    
  });

  export const setOtpForBeneVerification = (data) => ({
    type: MiscType.setOtpForBeneVerification,
    payload: data
    
  });

  export const setBeneRegister = (data) => ({
    type: MiscType.setBeneRegister,
    payload: data
    
  });

  //add partner name
  export const setPartner = (data) => ({
    type: MiscType.setPartner,
    payload: data
    
  });

  export const setRequesterId = (data) => ({
    type: MiscType.setRequesterId,
    payload: data
    
  });

  export const setLogoName = (data) => ({
    type: MiscType.setLogoName,
    payload: data
    
  });
  export const setClientRole = (data) => ({
    type: MiscType.setClientRole,
    payload: data
    
  });
  export const setTaLoadPermission = (data) => ({
    type: MiscType.setTaLoadPermission,
    payload: data
    
  });

  export const setFilterStartDate = (data) => ({
    type: MiscType.setFilterStartDate,
    payload: data
    
  });
  export const setFilterEndDate = (data) => ({
    type: MiscType.setFilterEndDate,
    payload: data
    
  });

  export const setMiscCallBackUrl = (data) => ({
    type: MiscType.setMiscCallBackUrl,
    payload: data
    
  });


  export const setClaimResp = (data) => ({
    type: MiscType.setClaimResp,
    payload: data
    
  });

  export const setRetailerBlanceShow = (data) => ({
    type: MiscType.setRetailerBlanceShow,
    payload: data
    
  });


  export const setClaimLoadShow = (data) => ({
    type: MiscType.setClaimLoadShow,
    payload: data
    
  });

  
  export const setRetailerBalanceVal = (data) => ({
    type: MiscType.setRetailerBalanceVal,
    payload: data
    
  });

  export const setDashboardPageGraphMonth = (data) => ({
    type: MiscType.setDashboardPageGraphMonth,
    payload: data
    
  });

  export const setTimeoutModal = (data) => ({
    type: MiscType.setTimeoutModal,
    payload: data
    
  });

  export const setBillPayShow = (data) => ({
    type: MiscType.setBillPayShow,
    payload: data
    
  });




  export const setRechargeShow = (data) => ({
    type: MiscType.setRechargeShow,
    payload: data
    
  });

  
  export const setPayoutShow = (data) => ({
    type: MiscType.setPayoutShow,
    payload: data
    
  });


  export const setAepsShow = (data) => ({
    type: MiscType.setAepsShow,
    payload: data
    
  });

  export const setDMTShow = (data) => ({
    type: MiscType.setDMTShow,
    payload: data
    
  });

  export const setKycShow = (data) => ({
    type: MiscType.setKycShow,
    payload: data
    
  });
  export const setSavedOtpDetails = (data) => ({
    type: MiscType.setSavedOtpDetails,
    payload: data
    
  });

  export const setErrMsg = (data) => ({
    type: MiscType.setErrMsg,
    payload: data
    
  });

  
  export const setResetPasswordLoader = (data) => ({
    type: MiscType.setResetPasswordLoader,
    payload: data
    
  });

  export const resetMiscData ={
    type: MiscType.RESET
  }

